import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  chat: {
    backgroundColor: '#F1F1F1',
    color: theme.palette.text.primary,
    borderRadius: 28,
    minHeight: 56,
    padding: theme.spacing(1, 2),
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '&:not($chatMine)': {
      marginRight: 'auto',
      borderBottomLeftRadius: 0
    },
    '&$withDeleteButton': {
      paddingRight: theme.spacing(0.5)
    }
  },
  withDeleteButton: {},
  chatMine: {
    marginLeft: 'auto',
    borderBottomRightRadius: 0
  },
  chatTypography: {
    fontFamily: ['Poppins', 'sans-serif'].join(','),
    fontSize: '0.85rem',
    '& > span': {
      fontWeight: 700
    }
  },
  button: {
    margin: '0 12px',
    padding: 6,
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.1)'
    }
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/ChatList/Chat/styles.js